import {ArrowUpOutlined, StopOutlined} from '@ant-design/icons'
import {DraftIconButton} from './DraftButton.jsx'
import {useAiContext} from './AiContext.mjs'

const ButtonSend = ({disabled, ...props}) => {
    const ai = useAiContext()
    const isDisabled = disabled || ! ai.getIsReady()

    return (
        <DraftIconButton
            disabled={isDisabled}
            title="发送"
            type="primary"
            onClick={() => ai.run()}
            {...props}
        >
            <ArrowUpOutlined />
        </DraftIconButton>
    )
}

const ButtonStop = props => {
    const ai = useAiContext()

    return (
        <DraftIconButton
            title="停止"
            type="primary"
            onClick={() => ai.stop()}
            {...props}
        >
            <StopOutlined />
        </DraftIconButton>
    )
}

export const ButtonMain = props => {
    const ai = useAiContext()

    if (ai.getIsRunning()) {
        return <ButtonStop {...props} />
    }
    else {
        return <ButtonSend {...props} />
    }
}
